

const useStyles = () => {
  return {
    container:'w-full h-full  md:px-52 px-5  flex flex-col justify-center pt-14 text-white  backdrop-blur-sm ',
      subContainer:' max-w-[1000px] mx-auto p-4 flex flex-col justify-center ',
      workText:'text-4xl font-bolt inline border-b-4 text-white font-bold border-white ',
      text:'my-6 text-lg  ',
      containerWorks:'grid  sm:grid-cols-2 md:grid-cols-2 gap-4  ',
      workBox:'  p-5  ',
      bg:'shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div opacity-100 hover:opacity-70 ',
      hover:'opacity-0 group-hover:opacity-100 ',
      title:'text-2xl font-bold text-white grid justify-center ',
      Btns:'pt-8 text-center',
      DemoBtn:'text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg',
      foot:'m-2 pt-2 ',
      CodeBtn:'text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg',
    }
}

export default useStyles